import { ME_URL } from '../constants';

export const COOKIES_REQUIRED_MESSAGE =
  'Signing in requires cookies to be enabled for this site. ' +
  'Please allow cookies for this site in your browser settings and try again.';

// Sign-in sets the auth cookie; if the browser blocks cookies it is silently
// dropped and every signed-in request would then fail. Call this right after a
// successful sign-in: it returns false only when the server confirms the
// cookie did not come back (401). Network/other errors return true so a
// transient failure never blocks sign-in.
export async function isAuthCookieAccepted() {
  try {
    const res = await fetch(`${ME_URL}/session`, { credentials: 'include' });
    return res.status !== 401;
  } catch {
    return true;
  }
}
